// @flow
import type { Dispatch } from 'redux'
import { connect } from 'react-redux'
import type { AppStateType } from '../../../reducers/appstate'
import ConversionPaywallModal from './ConversionPaywallModal'
import type { PropsType, DispatchPropsType } from './ConversionPaywallModal'
import { togglePromoModal } from '../../../actions/promoActions'
import { hunkQuizCopy, tropeQuizCopy } from '@components/quiz/quizCopy.js'
import { userSubscriptionExpiring } from '../../../models/User'

type OwnPropsType = {
  defaultSignIn: boolean,
  subtype: 'monthly' | 'annual',
  subscriptionOfferCta: string,
  subscriptionOfferTitle: string,
  subscriptionOfferSubtitle: string,
  subscriptionOfferSubtext: string,
  isBlackFriday?: boolean,
  isFullScreen?: boolean,
  notificationCompensation?: boolean,
  pageSlugForPromoEvent?: string,
  existingPromoCode?: string,
  bannerText?: string,
  isSocialPayButtonsFirst?: boolean
}

const mapStateToProps = (state: AppStateType, ownProps: OwnPropsType): any => {
  let isExistingQuizResult = false
  if (state.quizResult) {
    if (hunkQuizCopy.results[state.quizResult] || tropeQuizCopy.results[state.quizResult]) {
      isExistingQuizResult = true
    }
  }

  return ({
    isExpiring: userSubscriptionExpiring(state.user),
    isVisible: state.promoFlowModalOpen,
    isLoggedIn: !!(state.user && state.user.id),
    isSubscribed: !!state.user.isSubscribed,
    isPurchaseSuccess: !!(state.subscriptionPurchase && state.subscriptionPurchase.isSuccessful),
    notificationCompensation: ownProps.notificationCompensation,
    defaultSignIn: ownProps.defaultSignIn,
    subtype: ownProps.subtype,
    subscriptionOfferCta: ownProps.subscriptionOfferCta,
    subscriptionOfferTitle: ownProps.subscriptionOfferTitle,
    subscriptionOfferSubtitle: ownProps.subscriptionOfferSubtitle,
    subscriptionOfferSubtext: ownProps.subscriptionOfferSubtext,
    isExistingQuizResult,
    isBlackFriday: ownProps.isBlackFriday,
    textAuthSubheader: state.textAuthSubheader,
    isFullScreen: ownProps.isFullScreen,
    textSubscriptionConfirmationHeader: state.textSubscriptionConfirmationHeader,
    textSubscriptionConfirmationSubheader: state.textSubscriptionConfirmationSubheader,
    pageSlugForPromoEvent: ownProps.pageSlugForPromoEvent,
    existingPromoCode: ownProps.existingPromoCode,
    bannerText: ownProps.bannerText,
    isSocialPayButtonsFirst: !!ownProps.isSocialPayButtonsFirst
  }: PropsType)
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return ({
    dismissPromoModal: (): void => dispatch(togglePromoModal())
  }: DispatchPropsType)
}

export default connect<PropsType & DispatchPropsType, OwnPropsType, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(ConversionPaywallModal)
